import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cb0ebb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center" }
const _hoisted_2 = { class: "text-center position-relative" }
const _hoisted_3 = {
  key: 0,
  class: "logo"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "description mt-3 mb-2 text-uppercase font-weight-bold" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "logo", {}, () => [
        (!!_ctx.thumb)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                src: _ctx.thumb,
                alt: ""
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true)
      ], true),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "description", {}, () => [
          _createElementVNode("div", { innerHTML: _ctx.description }, null, 8, _hoisted_6)
        ], true)
      ]),
      (!!_ctx.btnLabel)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-lg btn-primary f-bold mt-2 mb-2",
            type: "button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.btnLabel), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "note", {}, undefined, true)
    ])
  ]))
}